import { taskApi } from 'api';

export const getTaskAttachment = async (taskId: string, serviceAgreementUid: string): Promise<Blob> => {
  const response = await taskApi.getTaskAttachmentRaw({ serviceAgreementUid, taskUid: taskId });
  return response.raw.blob();
};
